var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticClass: "x-footer" },
    [
      _c(
        "x-container",
        { attrs: { fluid: "", "app-width": "" } },
        [
          _c(
            "x-layout",
            { attrs: { "justify-space-between": "", "align-center": "" } },
            [
              _c("x-flex", { attrs: { xs3: "" } }, [
                _c("div", { staticClass: "x-footer__links mb-3" }, [
                  _c("ul", [
                    _c("li", [
                      _c("a", { on: { click: _vm.download } }, [
                        _c("u", [_vm._v("Terms & Conditions")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://www.howdengroup.com/howden-privacy-data-protection-policy",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Privacy Policy")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c("router-link", { attrs: { to: "/cookie-policy" } }, [
                          _vm._v("Cookie Policy"),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "x-footer__copyright" }, [
                  _c("p", [
                    _vm._v(
                      "© " +
                        _vm._s(new Date().getFullYear()) +
                        " xTrade Core. One Creechurch place, London, EC3A 5AF."
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "x-flex",
                { staticClass: "text-xs-right", attrs: { xs3: "" } },
                [
                  _c("span", { staticClass: "x-footer__powered-by" }, [
                    _vm._v("Powered by xTrade"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }